// dtemplate generated - do not edit
export const Template= (function() {	
	let templates =
		{"Board":"\u003ctemplate\u003e\n\t\u003cheader\u003e\n\t\t\u003c!-- \u003cdiv data-set=\"id\"\u003e#\u003c/div\u003e --\u003e\n\t\t\u003cdiv data-set=\"title\"\u003eboard title\u003c/div\u003e\n\t\u003c/header\u003e\n\t\u003csection data-set=\"messages\" class=\"messages\"\u003e\n\t\u003c/section\u003e\n\t\u003cfooter\u003e\n\t\t\u003ca href=\"#\" data-set=\"add_message\" class=\"poster\"\u003e\n\u003c!-- \t\t\t\u003csvg viewBox=\"0 0 10 10\"\u003e\n\t\t\t\t\u003cg\u003e\n\t\t\t\t\t\u003cpath d=\"M5 2L5 8M2 5L8 5\" /\u003e\n\t\t\t\t\u003c/g\u003e\n\t\t\t\u003c/svg\u003e --\u003e\n\t\t\tpost a new message\n\t\t\u003c/a\u003e\n\t\u003c/footer\u003e\n\u003c/template\u003e\n","BoardList":"\u003cdiv class=\"boardlist\" data-set=\"list\"\u003e\n\u003c/div\u003e\n","BoardPost":"\u003cdialog class=\"board-post\"\u003e\n\t\u003cheader\u003ePost a Message\u003c/header\u003e\n\t\u003clabel\u003eYour name\n\t\t\u003cinput type=\"text\" data-set=\"name\" value=\"\"/\u003e\n\t\u003c/label\u003e\n\t\u003clabel\u003eYour email\n\t\t\u003cinput data-set=\"email\" value=\"\" type=\"email\"/\u003e\n\t\u003c/label\u003e\n\t\u003cdiv\u003e\n\t\t\u003cdiv data-set=\"editor\"\u003e\n\t\t\u003c/div\u003e\n\t\u003c/div\u003e\n\t\u003cdiv class=\"buttons\"\u003e\n\t\t\u003cbutton data-set=\"cancel\" aria-label=\"cancel posting a message\"\u003ecancel\u003c/button\u003e\n\t\t\u003cbutton data-set=\"post\" aria-label=\"post this message\"\u003epost\u003c/button\u003e\n\t\u003c/div\u003e\n\u003c/dialog\u003e\n","Message":"\u003cdiv class=\"Message\"\u003e\n\t\u003cheader\u003e\n\t\t\u003cspan data-set=\"user\"\u003e \u003c/span\u003e\n\t\t\u003cspan data-set=\"date\"\u003e \u003c/span\u003e\n\t\u003c/header\u003e\n\t\u003csection class=\"message\" data-set=\"message\"\u003e\n\t\u003c/section\u003e\n\t\u003cfooter\u003e\n\t\t\u003ca data-set=\"hidereplies\" aria-label=\"toggle display of replies\"\u003e\n\t\t\t\u003cspan class=\"hidereplies_hide\"\u003ehide\u003c/span\u003e\u003cspan class=\"hidereplies_show\"\u003eshow\u003c/span\u003e replies\n\t\t\u003c/a\u003e\n\t\t\u003ca data-set=\"delete\" class=\"admin\" aria-label=\"delete this message and all replies\"\u003e\n\t\t\tdelete\n\t\t\u003c/a\u003e\n\t\t\u003ca data-set=\"reply\" aria-label=\"reply to this message\" class=\"poster\"\u003ereply\n\u003c!-- \t\t\t\u003csvg viewBox=\"0 0 10 10\"\u003e\n\t\t\t\t\u003cg\u003e\n\t\t\t\t\t\u003cpath d=\"M5 2L5 8M2 5L8 5\" /\u003e\n\t\t\t\t\u003c/g\u003e\n\t\t\t\u003c/svg\u003e\n --\u003e\t\t\u003c/a\u003e\n\t\u003c/footer\u003e\n\t\u003cdiv class=\"replies\" data-set=\"replies\"\u003e\n\t\u003c/div\u003e\n\u003c/div\u003e\n","Quilter":"\u003ctemplate\u003e\n\u003cdiv id=\"quilter\" data-set=\"editor\"\u003e\n  \u003cp\u003eHello World!\u003c/p\u003e\n  \u003cp\u003eSome initial \u003cstrong\u003ebold\u003c/strong\u003e text\u003c/p\u003e\n  \u003cp\u003e\u003cbr/\u003e\u003c/p\u003e\n\u003c/div\u003e\n\u003c/template\u003e\n"};

	let mk = function(k, html) {
		let el = document.createElement('div');
		el.innerHTML = html;
		//console.log("mk(",k,") html = ", html);

		let c = el.firstElementChild;
		while ((null!=c) && (Node.ELEMENT_NODE!=c.nodeType)) {
			c = c.nextSibling;
		}
		if (null==c) {
			console.error("FAILED TO FIND ANY ELEMENT CHILD OF ", k, ":", el)
			return mk('error', '<em>No child elements in template ' + k + '</em>');
		}
		el = c;
		if ('function'==typeof el.querySelector) {
			let et = el.querySelector('[data-set="this"]');
			if (null!=et) {
				el = et;
				el.removeAttribute('data-set');
			}
		}
		return el;
	}

	return function(t, dest={}) {
		// Return a deep copy of the node, created on first use
		let n = templates[t];
		if ('string'==typeof(n)) {			
			n = mk(t, n);
			templates[t] = n;
		}
		if ('undefined'==typeof n) {
			console.error('Failed to find template ' + t);
			return [false,false];
		}
		if (n.content) {
			n = n.content.cloneNode(true);
		} else {
			n = n.cloneNode(true);
		}
		try {
			for (let attr of ['id', 'data-set']) {
				let nodes = Array.from(n.querySelectorAll('[' + attr + ']'));
				if ('function'==typeof n.hasAttribute && n.hasAttribute(attr)) {
					nodes.unshift(n);
				}
				for (let el of nodes) {
					let a = el.getAttribute(attr);
					if (a.substr(0,1)=='$') {
						a = a.substr(1);
						el = jQuery(el);
						el.setAttribute(attr, a);
					}
					dest[a] = el;
				}
			}
		} catch (err) {
			console.error("ERROR in DTemplate(" + t + "): ", err);
			debugger;
		}
		return [n,dest];
	}
})();
